import { formatPrice } from '@helpers/formatPrice';
import { GetBillingAccountResponseDto } from 'app/API';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  className?: string;
  billingAccount?: GetBillingAccountResponseDto;
};

export const AudioHourRateCard = ({ className = '', billingAccount }: TProps) => {
  const rate = billingAccount?.tierRate ?? 0;
  const description = <div className="rate">{formatPrice(rate)}/Hr</div>;

  return (
    <Wrapper className={className}>
      <div className="content">
        <h2 className="title">Audio Hour Rate</h2>
      </div>

      <div className="info">{description}</div>
      <div className="description">Your cost per audio hour transcription</div>
    </Wrapper>
  );
};
